import {
  listPortfoliosRoutine,
  getPortfolioRoutine,
  createPortfolioRoutine,
  updatePortfolioRoutine,
  deletePortfolioRoutine,
} from './actions'
import initialState from './state'

export default function portfolioReducer(state = initialState, action = {}) {
  switch (action.type) {
    case listPortfoliosRoutine.REQUEST:
      return { ...state, isLoading: true }
    case listPortfoliosRoutine.SUCCESS:
      return { ...state, list: action.payload, isLoading: false }
    case listPortfoliosRoutine.FAILURE:
      return { ...state, isLoading: false }

    case getPortfolioRoutine.REQUEST:
      return { ...state, isLoading: true, selectedError: null }
    case getPortfolioRoutine.SUCCESS:
      return { ...state, selected: action.payload, isLoading: false }
    case getPortfolioRoutine.FAILURE:
      return { ...state, isLoading: false, selectedError: action.payload || true }

    case createPortfolioRoutine.SUCCESS:
      return { ...state, list: [...state.list, action.payload] }

    case updatePortfolioRoutine.SUCCESS:
      return {
        ...state,
        list: state.list.map(p => p.id === action.payload.id ? { ...p, ...action.payload } : p),
        selected: state.selected?.id === action.payload.id
          ? { ...state.selected, ...action.payload }
          : state.selected,
      }

    case deletePortfolioRoutine.SUCCESS:
      return {
        ...state,
        list: state.list.filter(p => p.id !== action.payload),
        selected: state.selected?.id === action.payload ? null : state.selected,
      }

    default:
      return state
  }
}
